import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import idProofEvents from "./events/IDProofEvents";

var otpVerificationCodeEntryController = function ($injector, eventBus) {

    var vm = this;
    var $state = $injector.get('$state');
    var logger = ExternalLogger.getInstance('otpVerificationCodeEntryController');

    vm.options = {
        onConfirm: function (phoneNumber) {
            logger.debug('otpVerificationCodeEntryController - onConfirmClick - [{0}]', [phoneNumber ? phoneNumber : null]);
            eventBus.dispatch(idProofEvents.OTP_AGREE_ENTER_CODE, this);
            var params = {
                "phoneNumber": phoneNumber ? phoneNumber : null
            };
            $state.go('accountSetup', params);

        },
		
		onOtpError : function(state){
            logger.debug('state - [{0}]',[state ? state : null]);
			var params = {
                "optOut" : 'optOut-Modal'
            };
			
          
            $state.go('mailPin',params);

        },
        phoneNumber: null
    };

    vm.phoneNumber = null;
    vm.getPhoneNumber = function () {
        if ($state.params && $state.params.phoneNumber) {
            var phoneNumberParam = $state.params.phoneNumber;
            vm.phoneNumber = phoneNumberParam.replace(/\D+/g, '');
        }

        return vm.phoneNumber;

    };

    var otpService = $injector.get('otpService');
    vm.openOTPNoCodeModal = otpService.openOTPNoCodeModalModal;


    vm.init = function () {
        var method = "init()";
        var phoneNumber = vm.getPhoneNumber();
        if (phoneNumber) {
            vm.options.phoneNumber = phoneNumber;
            logger.debug("otpVerificationCodeEntryController - {0} - phoneNumber provided: [{1}]", [method, phoneNumber]);
        } else {
            logger.debug("otpVerificationCodeEntryController - {0} - phoneNumber NOT provided.", [method]);
        }
    };

    vm.init();
};

otpVerificationCodeEntryController.$inject = ['$injector', 'eventBus'];
export default otpVerificationCodeEntryController;
